import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./SectionOne.css";
import { FaRegHandPointRight } from "react-icons/fa";
function ExclusiveBenifits() {
  return (
    <section className="about-one">
      <div className="container">
        <div className="row">
          <div className="col-xl-6" style={{marginBlock:"auto"}}>
            <div className="about-one__leftff">
              <div className="section-title text-left">
                <span className="section-title__taglineeee">
                  FLyAbasin Express Benifits
                </span>
                <h2 className="section-title__title">
                  Exclusive Benefits for Abasinexpress Agents
                </h2>
              </div>
              
              <ul className="list-unstyled about-one__points">
                <li>
                  <div className="icoonnn">
                    <FaRegHandPointRight className="icon-tick" />
                  </div>
                  <div className="textttt">
                    <p>
                      Personalized Support:{" "}
                      <span
                        style={{
                          fontWeight: "400",
                          color: "#000",
                          fontSize: "15px",
                        }}
                      >
                        Our dedicated account managers are here to assist you
                        personally. Get tailored advice, industry insights, and
                        support to help you succeed.
                      </span>
                    </p>
                  </div>
                </li>
                <li>
                  <div className="icoonnn">
                    <FaRegHandPointRight className="icon-tick" />
                  </div>
                  <div className="textttt">
                    <p>
                      Collaborate with Leading Airlines:{" "}
                      <span
                        style={{
                          fontWeight: "400",
                          color: "#000",
                          fontSize: "15px",
                        }}
                      >
                        Benefit from our partnerships with renowned airlines.
                        Access special deals, discounts, and unique offerings
                        for your clients.
                      </span>
                    </p>
                  </div>
                </li>
                <li>
                  <div className="icoonnn">
                    <FaRegHandPointRight className="icon-tick" />
                  </div>
                  <div className="textttt">
                    <p>
                    Hotel and Car Rental Packages:{" "}
                      <span
                        style={{
                          fontWeight: "400",
                          color: "#000",
                          fontSize: "15px",
                        }}
                      >
                    Extend your services beyond flights. Explore bundled packages with exclusive rates for hotels and car rentals, providing your clients with a complete travel experience.
                      </span>
                    </p>
                  </div>
                </li>
                <li>
                  <div className="icoonnn">
                    <FaRegHandPointRight className="icon-tick" />
                  </div>
                  <div className="textttt">
                    <p>
                    Enhanced Security and Compliance:{" "}
                      <span
                        style={{
                          fontWeight: "400",
                          color: "#000",
                          fontSize: "15px",
                        }}
                      >
                       Rest easy knowing that Abasinexpress prioritizes the security of your data and transactions. Our platform complies with industry standards, providing a secure environment for all your business activities.</span>
                    </p>
                  </div>
                </li>
              </ul>
              
            </div>
          </div>
          <div className="col-xl-6">
            <div className="about-one__right">
              <div
                className="about-one__img-box wow slideInRight animated"
                data-wow-delay="100ms"
                data-wow-duration="2500ms"
                style={{
                  visibility: "visible",
                  animationDuration: "2500ms",
                  animationDelay: "100ms",
                  animationName: "slideInRight",
                }}
              >
                <div className="about-one__imgsss">
                  <img
                    src="https://jetly-html.vercel.app/main-html/assets/images/resources/about-one-img-1.jpg"
                    alt=""
                  />
                </div>
                <div className="about-one__satisfied">
                  <div className="about-one__satisfied-icon">
                    <span className="icon-recommend" />
                  </div>
                  <div className="about-one__satisfied-content count-box counted">
                    <h3
                      className="count-text"
                      data-stop={8800}
                      data-speed={1500}
                    >
                      200+
                    </h3>
                    <p>Satisfied Agents</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ExclusiveBenifits;
